import { render, staticRenderFns } from "./InfoData.vue?vue&type=template&id=1b371587&scoped=true"
import script from "./InfoData.vue?vue&type=script&lang=js"
export * from "./InfoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b371587",
  null
  
)

export default component.exports